// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7ac49621","703":"ef76aaff"}[chunkId] + ".chunk.js";
};